// Byte encodings the wire needs: UTF-8 for JSON bodies, standard base64 for
// the byte-slice fields Go marshals (`encoding/json` renders a []byte as
// padded standard base64), base64url for a carrier's two parts, lowercase
// base32 without padding for the principal token. Internal.
const encoder = new TextEncoder();
const decoder = new TextDecoder();
export function utf8Encode(s) {
    return encoder.encode(s);
}
export function utf8Decode(b) {
    return decoder.decode(b);
}
// A 64 KiB value must never be spread into one call's arguments.
const chunk = 8192;
export function base64Encode(bytes) {
    let binary = "";
    for (let i = 0; i < bytes.length; i += chunk) {
        binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
    }
    return btoa(binary);
}
export function base64Decode(s) {
    const binary = atob(s);
    const out = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        out[i] = binary.charCodeAt(i);
    }
    return out;
}
export function base64UrlEncode(bytes) {
    return base64Encode(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function base64UrlDecode(s) {
    const padded = s.replace(/-/g, "+").replace(/_/g, "/") + "=".repeat((4 - (s.length % 4)) % 4);
    return base64Decode(padded);
}
export function hexEncode(bytes) {
    let out = "";
    for (const b of bytes) {
        out += b.toString(16).padStart(2, "0");
    }
    return out;
}
// The RFC 4648 alphabet, lowercased: every character is a subject token
// character and survives the tag lowercasing a template expansion applies.
const base32Alphabet = "abcdefghijklmnopqrstuvwxyz234567";
export function base32Encode(bytes) {
    let out = "";
    let value = 0;
    let bits = 0;
    for (const b of bytes) {
        value = ((value << 8) | b) & 0xffff;
        bits += 8;
        while (bits >= 5) {
            out += base32Alphabet.charAt((value >>> (bits - 5)) & 31);
            bits -= 5;
        }
    }
    if (bits > 0) {
        out += base32Alphabet.charAt((value << (5 - bits)) & 31);
    }
    return out;
}
//# sourceMappingURL=encoding.js.map